import { Button, IconPlus, Text } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconLightBulb, Tag } from 'ui'
import { NAME } from '../constants'
import { CardItem } from './CardItem'
import { CardLine } from './CardLine'
import { messages } from './messages'
import { styles } from './styles'

type Props = {
  form: FormState
  onMouseEnter: (example: string) => void
  onMouseLeave: () => void
}

const EXAMPLES = [
  {
    description: messages.example.first,
    formula: 'min(total * 0.1, 10)',
  },
  {
    description: messages.example.second,
    formula: '((total + freight) * 0.05)',
  },
  {
    description: messages.example.third,
    formula: 'quantity * 4.90',
  },
]

export function ExamplesCard(props: Props) {
  const { form, onMouseEnter, onMouseLeave } = props

  const { $t } = useIntl()

  const currentExpression: string | undefined = useWatch({
    form,
    name: NAME,
  })

  const [previousExpression, setPreviousExpression] = useState<
    string | undefined
  >()
  const [exampleClicked, setExampleClicked] = useState<boolean>(false)

  const handleOnMouseEnter = (expression: string) => {
    setPreviousExpression(currentExpression)
    form.setValue(NAME, '')
    onMouseEnter(expression)
  }

  const handleOnMouseLeave = () => {
    if (exampleClicked) {
      setExampleClicked(false)
    } else {
      form.setValue(NAME, previousExpression)
    }

    onMouseLeave()
  }

  const handleOnClick = (expression: string) => {
    setExampleClicked(true)
    form.setValue(NAME, expression)
  }

  return (
    <CardItem
      name="examples"
      icon={<IconLightBulb />}
      title={$t(messages.example.title)}
      link={$t(messages.example.link)}
    >
      {EXAMPLES.map(({ description, formula }, index) => (
        <CardLine columns="fill" key={index}>
          <div className={styles.card.example}>
            <Text>
              <FormattedMessage {...description} />
            </Text>
            <div>
              <Tag>{formula}</Tag>
            </div>
          </div>
          <Button
            onMouseEnter={() => handleOnMouseEnter(formula)}
            onClick={() => handleOnClick(formula)}
            onMouseLeave={handleOnMouseLeave}
            variant="tertiary"
            icon={<IconPlus />}
          />
        </CardLine>
      ))}
    </CardItem>
  )
}
